module.exports = __webpack_public_path__ + "static/media/bg.8d30c152.jpg";